import React, { Fragment } from 'react'
import Box from '@material-ui/core/Box'
import useStyles from './styles'
import { Typography, Button } from '@material-ui/core'
import { isEmpty } from 'lodash'
import { HeaderImage } from './Image'
import { useDispatch } from 'react-redux'
import { openDialog } from 'actions/dialogs'
import Scrollbars from 'react-scrollbars-custom'
import AutoSizer from 'react-virtualized-auto-sizer'
import { useSelector } from 'react-redux'
import classnames from 'clsx'

const ItemDetails = ({ zIndex }) => {
  const classes = useStyles()

  const orientation = useSelector(state => state.window.orientation)

  const dispatch = useDispatch()

  const items = useSelector(state => state.items.items)
  const item = items.find(i => i.is_live)

  let midStyle = {}

  const openItemDialog = () => {
    dispatch(openDialog('item', item))
  }

  return (
    <AutoSizer>
      {({ height, width }) => (
        <Scrollbars
          style={{
            height,
            width
          }}
          permanentTracks={false}
          // removeTracksWhenNotUsed
          disableTracksWidthCompensation
        >
          <Box
            className={classnames(
              classes.itemDetailsContainer,
              classes[orientation]
            )}
            style={{ zIndex: zIndex ? 5 : 'inherit', height: height }}
          >
            <Box style={midStyle} className={classes.itemContent}>
              {!isEmpty(item) && (
                <Fragment>
                  <Box className={classes.imageBox}>
                    <Button
                      variant="contained"
                      className={classes.detailsButton}
                      onClick={openItemDialog}
                    >
                      Click to see full details
                    </Button>
                    {item.image && item.image.length > 0 && (
                      <HeaderImage image={item.image[0]} />
                    )}
                  </Box>
                  <Box className={classes.detailsBox}>
                    {item.value_display !== 2 ? (
                      <Typography
                        variant="h3"
                        color="primary"
                        className={classes.retailValue}
                      >
                        Retail Value:{' '}
                        {item.value_display === 0
                          ? '$' + item.value
                          : 'Priceless'}
                      </Typography>
                    ) : null}
                    <Typography
                      className={classes.itemTitleTypography}
                      color="secondary"
                      variant="h2"
                    >
                      {item.name}
                    </Typography>
                    <Typography className={classes.itemIDTypography}>
                      Item ID: {item.item_code}
                    </Typography>
                    <Box className={classes.itemDescriptionTypography}>
                      <AutoSizer>
                        {({ height, width }) => (
                          <Scrollbars
                            style={{
                              height,
                              width
                            }}
                            permanentTracks={false}
                            // removeTracksWhenNotUsed
                            // disableTracksWidthCompensation
                          >
                            <Typography
                              dangerouslySetInnerHTML={{
                                __html: item.formattedDescription
                              }}
                            />
                          </Scrollbars>
                        )}
                      </AutoSizer>
                    </Box>
                  </Box>
                </Fragment>
              )}
            </Box>
          </Box>
        </Scrollbars>
      )}
    </AutoSizer>
  )
}

export default ItemDetails



// WEBPACK FOOTER //
// ./src/components/ItemDetails/index.jsx